import { useCallback, useState, useMemo, ReactElement, ReactNode } from 'react';
import { PreferencesContext, Prefs } from './context';

const LOCAL_STORAGE_KEY = 'app_preferences';

type Props = {
    readonly children?: ReactNode;
};
export function PreferencesProvider({ children }: Props): ReactElement {
    const [prefsRaw, __setPrefsRaw] = useState<string | null>(
        localStorage.getItem(LOCAL_STORAGE_KEY)
    );
    const setPrefsRaw = (prefsRaw: string) => {
        localStorage.setItem(LOCAL_STORAGE_KEY, prefsRaw);
        __setPrefsRaw(prefsRaw);
    };

    const prefs = useMemo<Prefs>(() => {
        if (prefsRaw === null) {
            return {};
        } else {
            try {
                return JSON.parse(prefsRaw) as Prefs;
            } catch {
                return {};
            }
        }
    }, [prefsRaw]);

    const setPrefs = useCallback(
        (key: string, value: string) => {
            setPrefsRaw(
                JSON.stringify({
                    ...prefs,
                    [key]: value
                })
            );
        },
        [prefs]
    );

    const removePrefs = useCallback(
        (key: string) => {
            if (key in prefs) {
                delete prefs[key];
                setPrefsRaw(JSON.stringify(prefs));
            } else {
                // noop
            }
        },
        [prefs]
    );

    return (
        <PreferencesContext.Provider
            value={{
                prefs,
                setPrefs,
                removePrefs
            }}
        >
            {children}
        </PreferencesContext.Provider>
    );
}
